(() => {
  if (window.BlacksmithDeliveryCurrency) {
    window.BlacksmithDeliveryCurrency.update(document);
    return;
  }

  const selector = '[data-delivery-local-price]';

  const roundConvertedAmount = (amount) => {
    if (!Number.isFinite(amount)) return amount;

    const absoluteAmount = Math.abs(amount);
    if (absoluteAmount < 20) return Math.round(amount);

    const roundingUnit = 10 ** Math.max(
      0,
      Math.floor(Math.log10(absoluteAmount)) - 1
    );

    return Math.round(amount / roundingUnit) * roundingUnit;
  };

  const formatCurrency = (amount, currency) => {
    const locale = document.documentElement.lang || 'en-AU';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(amount);
    } catch (error) {
      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }).format(amount);
      } catch (fallbackError) {
        return `${currency} ${Math.round(amount)}`;
      }
    }
  };

  const convertElement = (element) => {
    if (!(element instanceof Element)) return;

    const sourceCurrency = String(element.dataset.sourceCurrency || '').toUpperCase();
    const targetCurrency = String(element.dataset.targetCurrency || '').toUpperCase();
    const sourceAmount = Number(element.dataset.sourceAmount);

    if (!sourceCurrency || !targetCurrency || !Number.isFinite(sourceAmount)) return;

    let convertedAmount = sourceAmount;

    if (sourceCurrency !== targetCurrency) {
      if (sourceCurrency !== 'AUD') return;

      const shopifyCurrency = window.Shopify && window.Shopify.currency;
      const activeCurrency = shopifyCurrency && String(shopifyCurrency.active || '').toUpperCase();
      const exchangeRate = shopifyCurrency && Number(shopifyCurrency.rate);

      if (activeCurrency && activeCurrency !== targetCurrency) return;
      if (!Number.isFinite(exchangeRate) || exchangeRate <= 0) return;

      convertedAmount = roundConvertedAmount(sourceAmount * exchangeRate);
    }

    element.textContent = formatCurrency(convertedAmount, targetCurrency);
    element.dataset.deliveryCurrencyConverted = 'true';
  };

  const update = (root = document) => {
    if (root instanceof Element && root.matches(selector)) convertElement(root);
    root.querySelectorAll?.(selector).forEach(convertElement);
  };

  window.BlacksmithDeliveryCurrency = { update };

  const initialise = () => {
    update(document);
    window.setTimeout(() => update(document), 250);
    window.setTimeout(() => update(document), 1000);

    const observer = new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach((node) => {
          if (node instanceof Element) update(node);
        });
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', (event) => update(event.target));
})();
